import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9c6sy2bfcu: FaireBrandEntity = {
  token: "b_9c6sy2bfcu",
  type: "brand",
  name: "Moon Rituals",
  avatarUrl:
    "https://cdn.faire.com/fastly/a58ea9f1192236466fea24e9be395fa60ff0caa70b27b979016fe2d31571411f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/efeae5aeef38d4a59318caad2909bf75c00b4bc42a2351d8ce15c3518b798c4f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a58ea9f1192236466fea24e9be395fa60ff0caa70b27b979016fe2d31571411f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/efeae5aeef38d4a59318caad2909bf75c00b4bc42a2351d8ce15c3518b798c4f.jpeg",
  location: "Sydney, AUS",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 185,
  isTopShop: true,
  isInsider: false,
  description:
    '🌙 Moon Rituals Crystal – Your Premier Australian Partner for 2026\n\nWelcome to Moon Rituals Crystal. Based in Sydney, Australia, we specialize in high-quality, ethically sourced crystals and spiritual tools. From breathtaking one-of-a-kind (WYSIWYG) specimens to high-traffic retail essentials, our mission is to empower your store with sustainable, high-vibration products that align with the latest wellness trends.\n\n✨ Why Partner with Moon Rituals Crystal?\n\nUnique Designs & Craftsmanship: Exclusive, hand-selected pieces that help your shop stand out.\n\nWYSIWYG Guarantee: For our rare specimens, the exact piece you see is the one you receive.\n\nWeekly New Drops: We refresh our inventory every week to keep your shelves exciting.\n\nSustainable Sourcing: Conflict-free and responsibly mined crystals for the mindful retailer.\n\n💎 Global Shipping & 2026 Duty Guide\n\nWe’ve removed the "international" barrier to make wholesale as easy as local sourcing:\n\n🇦🇺 Australia (Domestic): We are based in Sydney! Enjoy lightning-fast, direct shipping across the country.\n\n🇺🇸 U.S. Retailers: We provide full DDP (Delivered Duty Paid). We handle all paperwork and cover the import process for a flat 10% tax rate—no surprise bills, no hassle.\n\n🇳🇿 🇪🇺 🇨🇦 NZ, EU, UK & Canada: Our shipments to these regions are currently 0% import tax, ensuring your landed cost remains low.\n\n🌍 Worldwide: Tracked, reliable shipping to the world. ',
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:10.081Z",
    importedBy: "entity-db-cli",
  },
};
